<template>
  <div>
    <Breadcrumbs main="Usuarios" title="Editar Trabajador" v-if="objectId"/>
    <Breadcrumbs main="Usuarios" title="Agregar Trabajador" v-else/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5 v-if="objectId">Editar Trabajador</h5>
              <h5 v-else>Agregar Trabajador</h5>
            </div>
            <div class="card-body">
              <b-form class="needs-validation">
                <div class="form-row">
                  <div class="col-md-12 mb-3">
                    <label for="username_id">RUT (requerido)</label>
                    <masked-input class="form-control" id="username_id"
                                  v-model="form.user.username.value"
                                  placeholder="12.345.678-9"
                                  :mask="maskRUT"
                    />
                    <b-form-invalid-feedback :state="form.user.username.is_valid">{{form.user.username.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="first_name_id">Nombres (requerido)</label>
                    <b-form-input
                            type="text" id="first_name_id" placeholder="Juan José"
                            v-model="form.user.first_name.value" >
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.user.first_name.is_valid">{{form.user.first_name.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="last_name_id">Apellidos (requerido)</label>
                    <b-form-input
                            type="text" id="last_name_id" placeholder="Perez Perez"
                            v-model="form.user.last_name.value" >
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.user.last_name.is_valid">{{form.user.last_name.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="email_id">Email (opcional)</label>
                    <b-form-input
                            type="email" id="email_id" placeholder="correo@gmail.com"
                            v-model="form.user.email.value" >
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.user.email.is_valid">{{form.user.email.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="password1_id" v-if="objectId">Contraseña (opcional)</label>
                    <label for="password1_id" v-else>Contraseña (requerido)</label>
                    <b-form-input
                            type="password" id="password1_id" placeholder=""
                            v-model="form.user.password1.value" >
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.user.password1.is_valid">{{form.user.password1.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="password2_id" v-if="objectId">Repetir Contraseña (opcional)</label>
                    <label for="password2_id" v-else>Repetir Contraseña (requerido)</label>
                    <b-form-input
                            type="password" id="password2_id" placeholder=""
                            v-model="form.user.password2.value" >
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.user.password2.is_valid">{{form.user.password2.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="color_id">Color en el mapa (requerido)</label>
                    <b-form-input
                            type="color" id="color_id" placeholder=""
                            v-model="form.color.value" value="#000000">
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.color.is_valid">{{form.color.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="type_id">Privilegio (requerido)</label>
                    <multiselect placeholder="Selecciona un privilegio" id="type_id"
                                 label="name" track-by="id"
                                 deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                 v-model="form.type.value" :options="form.type.options"
                                 :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                      <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                    </multiselect>
                    <b-form-invalid-feedback :state="form.type.is_valid">{{form.type.message_error}}</b-form-invalid-feedback>
                  </div>
                </div>
                <b-button type="button" variant="primary" @click="onSubmit" v-if="objectId">Editar trabajador</b-button>
                <b-button type="button" variant="success" @click="onSubmit" v-else>Agregar trabajador</b-button>
                <b-button type="button" variant="warning" class="ml-1" :to="{'name': 'CoreWorkerProfileList'}">Volver</b-button>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import axios from 'axios';
  import MaskedInput from 'vue-masked-input'
  import utils from '../../../utils';
  import Multiselect from "vue-multiselect";

  export default {
    components: {
      MaskedInput,
      Multiselect
    },
    data(){
      return {
        objectId: null,
        form: {
          "user": {
            username: utils.defaultFields(),
            first_name: utils.defaultFields(),
            last_name: utils.defaultFields(),
            password1: utils.defaultFields(),
            password2: utils.defaultFields(),
            email: utils.defaultFields({required: false}),
          },
          color: utils.defaultFields({value: '#000000'}),
          type: utils.defaultFields(
              {
                _type: 'select',
                options: utils.privilegeUser
              }
          ),
        },
        maskRUT: {
          pattern: '##.###.###-V',
          formatCharacters: {
            'V': {
              validate: char => /[1-9kK]/.test(char),
              transform: char => char.toUpperCase(),
            },
            '#': {
              validate: char => /[0-9]/.test(char),
            },
          },
        },
      }
    },
    mounted () {
      this.objectId = this.$route.params.objectId;
      if(this.objectId){
        this.loadData(this.objectId);
      }
    },
    methods: {
      onSubmit(evt){
        // console.log(evt)
        evt.preventDefault();
        // AQUÍ GUARDARÉ EL JSON FINAL PARA QUE SEA ENVIADO AL POST
        let data = {};
        const is_valid = utils.generateJsonStructure(this.form, data);
        if(data['user']['password1'] === "" && data['user']['password2'] === ""){
          delete data['user']['password1'];
          delete data['user']['password2'];
        }
        if(is_valid){
          let _type = 'agregar al trabajador';
          if(this.objectId){
            _type = 'modificar el trabajador'
          }
          this.$swal({
            title: 'Información',
            type: 'info',
            html: `Estás a punto de ${_type} <b>${this.form.user.first_name.value} (${this.form.user.last_name.value}) (${this.form.user.username.value})</b>.`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#28a745',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
            cancelButtonColor: '#dc3545',
            cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              if(!this.objectId){
                const path = '/api/core/v1.0/worker_profile/';
                await axios.post(path, data).then(async (response) => {
                  // console.log(response);
                  await this.$swal({
                    title: 'Agregado',
                    type: 'success',
                    html: `Se ha agregado al trabajador <b>${this.form.user.first_name.value} (${this.form.user.last_name.value}) (${this.form.user.username.value})</b> de manera correcta.`,
                  }).then(() => {
                    this.$router.push({'name': 'CoreWorkerProfileList'});
                  });
                }).catch(async (error) => {
                  // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                  if(error.response.status === 400){
                    console.log(error.response);
                    utils.generateBackendError(this.form, error.response.data);
                    await this.$swal({
                      title: 'Error',
                      type: 'error',
                      html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                    });
                  }
                });
              } else {
                const path = `/api/core/v1.0/worker_profile/${this.objectId}/`;
                delete data['user']['username'];
                await axios.patch(path, data).then(async (response) => {
                  // console.log(response);
                  await this.$swal({
                    title: 'Modificado',
                    type: 'success',
                    html: `Se ha modificado al trabajador <b>${this.form.user.first_name.value} (${this.form.user.last_name.value}) (${this.form.user.username.value})</b> de manera correcta.`,
                  }).then(() => {
                    this.$router.push({'name': 'CoreWorkerProfileList'});
                  });
                }).catch(async (error) => {
                  // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                  console.log(error.response.data);
                  if(error.response.status === 400){
                    console.log(error.response);
                    utils.generateBackendError(this.form, error.response.data);
                    await this.$swal({
                      title: 'Error',
                      type: 'error',
                      html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                    });
                  }
                });
              }
            }
          });
        }else{
          this.$swal({
            title: 'Error',
            type: 'error',
            html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
          });
        }
      },
      async loadData(objectId){
        let data = {};
        let responseData;
        const defaultFieldValues = {
          'email': {required: false},
          type: {
            _type: 'select',
            options: [
              {id: 'ADM', name: 'Administrador'},
              {id: 'CON', name: 'Conductor'}
            ]}
        };
        const path = `/api/core/v1.0/worker_profile/${objectId}/`;
        await axios.get(path).then(async (response) => {
          responseData = response.data;
          await utils.loadDataStructure(data, responseData, defaultFieldValues);
        }).catch((error) => {
          console.log(error.response);
        });
        data['user']['password1'] = utils.defaultFields({required: false});
        data['user']['password2'] = utils.defaultFields({required: false});
        data['type'].value = data['type'].options.find(option => data['type'].value === option.id);
        await this.$set(
            this,
            'form',
            data
        );
      }
    }
  }
</script>